module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/exam/exam.component.css
// module id = ./src/app/exam/exam.component.css
// module chunks = main